<script>
export default{
    methods:{
        isMobile:function (){
            // console.log("screen width", document.body.clientWidth);
            return (window.navigator.userAgent.toLowerCase().includes("mobi") || document.body.clientWidth < 750);
        }
    }
    
}
</script>



// WEBPACK FOOTER //
// resources/js/shared/detect-mobile-mixin.vue